import React from 'react'
import './SectionTwo.css'
function SectionTwo() {
    return (
        <div
            className='section-two-body'
        >
            <img src='/section-two/main.gif'
                className='second-section-image'
            />
        </div>
    )
}

export default SectionTwo